<template>
  <div class="animated fadeIn">
    <b-card v-if="showList">
      <div slot="header">Group Account 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="showFilter=!showFilter">
            <i class="fa fa-filter"></i>Filter
          </button>
              <button class="btn btn-primary mr-1" @click="exportxls()">
                  <i class="fa fa-file-excel-o"></i>
                  Export
              </button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row v-if="showFilter" >
        <b-col lg="4">
          <b-form-group label-cols=3 label="Group Name">
              <b-form-input v-model="tblData.groupname"></b-form-input>
          </b-form-group>
        </b-col>
        <b-col lg="8">
          <b-form-group label-cols=1 label="Account">
              <b-row>
                <b-col class="pr-1" cols="2"><b-form-input v-model="tblData.kodeacc" placeholder="Code"></b-form-input></b-col>
                <b-col class="pr-1" cols="5"><b-form-input v-model="tblData.namaacc" placeholder="Account Name"></b-form-input></b-col>
                <b-col cols="5">
                  <b-row>
                    <b-button class="btn btn-success ml-3 mr-1" @click="refresh()" size="sm"> <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary" @click="clearFilter()" size="sm"> <i class="fa fa-eraser"></i>Clear Filter</b-button>
                  </b-row>
                </b-col>
              </b-row>                      
          </b-form-group>
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"
        @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="4" >
            <b-form-group label-cols=3 label="Limit per page" class="mb-0">
            <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  style="width:80px;"/>
            </b-form-group>
        </b-col>        
        <b-col cols="4">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
        <b-row class="justify-content-center">
          <b-col lg="7">
            <b-card v-if="showForm">
              <div slot="header">Group Account - Add/Edit Form 
                <div class="card-header-actions">
                  <button class="btn btn-primary mr-1" @click="save()">
                    <i class="fa fa-save"></i> Save
                  </button>
                  <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
                </div>
              </div>
                      <b-form-group  label-cols=3  label="Group Name" >
                          <b-form-input v-model="frmdata.groupname" :state="!$v.frmdata.groupname.$error"></b-form-input>
                                                <label style="font-size:smaller; font-styke: italic;">Special Group Name used by System  : 'PREPAID EXPENSE','PROJECT IN PROGRESS' </label>

                      </b-form-group>
                      <b-form-group label-cols=3  label="Account">
                          <b-input-group >
                              <b-form-input readonly v-model="frmdata.glAccount" :state="!$v.frmdata.kodeacc.$error"></b-form-input>
                              <b-input-group-append>
                              <b-btn text="Button" @click="showLkuCoa('debit')" >
                                  <i class="fa fa-search"></i>
                              </b-btn>
                              </b-input-group-append>
                          </b-input-group>
                      </b-form-group>
                      <br>
            </b-card>
          </b-col>
      </b-row>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"  :allowHeader="true"></lku-coa>
        </b-modal>        
  </div>
</template>


<script>
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import groupakun from "../../apis/groupakun";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  mixins: [validationMixin],
  validations: {
    frmdata: {
        groupname: { required },
        kodeacc: { required }
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      showFilter:false,
      lkuCoaShow:false,
      lkuCoaCaller:'debit',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      frmdata:{kodeacc: '', glAccount:''},
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        
        sortBy: 'groupname',
        sortDesc: false,
      },
    };
  },
  components: {lkuCoa},
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "groupname",
            thStyle: "width:150px",
            label: "Group Name",
            sortable: true
          },
          {
            key: "kodeacc",
            thStyle: "width:150px",
            label: "Account#",
            sortable: true
          },
          {
            key: "namaacc",
            label: "Account Name",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:40px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },

  },
  methods: {       
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await groupakun.list(this.tblData);      
      return list;
    },
    exportxls: async function() {
      this.isLoading = true;
      try {
         await groupakun.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message);
        } else {
          toastr.error(JSON.stringify(error));
        }
      }
    },    
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    clearFilter(ctx) {
        this.tblData.kodeacc= '';
        this.tblData.namaacc=  '';
        this.tblData.groupname=  '';
        this.refresh();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      this.frmdata.grouplama = data.groupname;
      this.frmdata.kodelama = data.kodeacc;
      this.frmdata.glAccount = data.kodeacc.trim() + ' | ' + data.namaacc.trim();
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              await groupakun.save(this.frmdata);
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await groupakun.remove(this.model);
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
        // if (this.lkuCoaCaller==='debit'){
            this.frmdata.glAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata.kodeacc = _selected.kodeacc;
            this.frmdata.namaacc = _selected.namaacc;
        // } else {
        //     this.frmdata.krAccount = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
        //     this.frmdata.kr_kodeacc = _selected.kodeacc;
        //     this.frmdata.kr_namaacc = _selected.namaacc;
        // }
        this.lkuCoaShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push("home");
    },    
  }
};
</script>
